import { SocialExportUploadItemCard } from '@app/modules/social-export/publish/SocialExportUploadItemCard';
import { webApi } from '@mi-front/api-clients';
import { useComposition } from '../../hooks/useComposition';
import { useComposeSocialExportUploadItemCardActions } from './useComposeSocialExportUploadItemCardActions';

interface ComposeSocialExportUploadItemCardProps {
  upload: webApi.CompositionSocialUploadItemDto;
}

/**
 * Composition social upload card: delegates layout to shared social-export card.
 */
export function ComposeSocialExportUploadItemCard({
  upload,
}: ComposeSocialExportUploadItemCardProps) {
  const { composition } = useComposition();
  const { trigger: actionsTrigger, menuAndDialog: actionsMenuAndDialog } =
    useComposeSocialExportUploadItemCardActions({ compositionId: composition.id, upload });

  return (
    <SocialExportUploadItemCard
      upload={upload}
      actionsTrigger={actionsTrigger}
      actionsMenuAndDialog={actionsMenuAndDialog}
    />
  );
}
